import Animate from './animate'
import ApproachSteps from './approach-steps'
import ApproachStepsDropdown from './approach-steps-dropdown'
import BlogLoadMore from './blog-load-more'
import Cookie from './cookie'
import filterBtn from './filter-btn'
import Footer from './footer'
import FormLined from './form-lined'
import GalleryCarousel from './gallery-carousel'
import Header from './header'
import LangPicker from './lang-picker'
import LoadMore from './load-more'
import ModalAnchors from './modal-anchors'
import ModalContact from './modal-contact'
import ModalGallery from './modal-gallery'
import PageTransition from './page-transition'
import Partners from './partners'
import Pinterest from './pinterest'
import Sprig from './sprig'
import Sticker from './sticker'
import Team from './team'
import UnderlineMultiple from './underline-multiple'
import VimeoViewport from './vimeoViewport'

export const shouldInit = [
  Header,
  Partners,
  LangPicker,
  Sticker,
  Footer,
  FormLined,
  LoadMore,
  BlogLoadMore,
  GalleryCarousel,
  Team,
  ModalAnchors,
  ModalContact,
  ModalGallery,
  ApproachSteps,
  ApproachStepsDropdown,
  Animate,
  Cookie,
  PageTransition,
  UnderlineMultiple,
  Pinterest,
  Sprig,
  filterBtn,
  VimeoViewport
]

export const shouldUpdate = [
  Header,
  Partners,
  LangPicker,
  Sticker,
  Footer,
  FormLined,
  LoadMore,
  BlogLoadMore,
  GalleryCarousel,
  Team,
  ModalAnchors,
  ModalContact,
  ModalGallery,
  ApproachSteps,
  ApproachStepsDropdown,
  Animate,
  UnderlineMultiple,
  Sprig,
  filterBtn,
  VimeoViewport
]
